import retrieveDaqsJson from './retrieve-daqs-json'
import tableAdapter from './tableAdapter'
import boatBins from './filters/boatBins'
import statesWithRegions from './filters/statesWithRegions'
import { components } from '@datavue/datavue-ui'
const ChloroplethHeatmap = () =>
  import('../components/charts/ChloroplethHeatmap')
const HorizontalBarchart = () =>
  import('../components/charts/HorizontalBarchart')
const GenericPage = () => import('@/components/pages/GenericPage')
const DaqsChart = () => import('@/components/DaqsChart')

export default class Exposure {
  title = 'Boat Use and Boater Exposure Information'
  key = 'exposure'
  pageComponent = GenericPage
  retrieveData = retrieveDaqsJson
  filters = function () {
    return {
      filter1boatbin: {
        label: 'Boat Category:',
        component: components['DatavueUiSelect'],
        options: boatBins
      },
      filter2stateorregion: {
        label: 'State/Region:',
        component: components['DatavueUiSelect'],
        options: statesWithRegions
      },
      metric: {
        label: 'Report the Results as:',
        component: components['DatavueUiSelect'],
        props: {
          inline: true
        },
        options: [
          {
            key: 'boats',
            label: 'Boats (in 1000s)',
            default: true
          },
          {
            key: 'hours_per_outing',
            label: 'Hours per Outing'
          },
          {
            key: 'boat_days',
            label: 'Boat Days'
          },
          {
            key: 'outings_per_day',
            label: 'Outings Per Day'
          }
        ]
      },
      measure: {
        label: 'Display results as:',
        component: components['DatavueUiRadioGroup'],
        props: {
          inline: true
        },
        options: [
          {
            key: 'count',
            label: 'Number',
            default: true
          },
          {
            key: 'percent',
            label: 'Percent'
          }
        ]
      }
    }
  }
  charts = function () {
    return {
      overall_outing_boats: {
        title: 'That Went Out On The Water',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      state_of_residence: {
        title: 'By State Of Residence',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          grid: 'map',
          tableLabel: 'State Of Residence',
          tableAdapter: tableAdapter
        }
      },
      region_of_residence: {
        title: 'By Region Of Residence',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'region',
          grid: 'map',
          tableLabel: 'Region Of Residence',
          tableAdapter: tableAdapter
        }
      },
      boatbin_outing_boats: {
        title: 'By Boat Category',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableLabel: 'Boat Category',
          tableAdapter: tableAdapter
        }
      }
    }
  }
}
